import {
  HotelBedType,
  HotelMealsIncluded,
  HotelRefundability,
  HotelRoomType,
  HotelSortBy,
  HotelViewType,
} from '@/modules/Search/types'

export const HOTEL_SORT_OPTIONS: { key: string; value: HotelSortBy }[] = [
  {
    key: 'search.hotelSortOptions.alphabetic',
    value: HotelSortBy.Alphabetic,
  },
  {
    key: 'search.hotelSortOptions.price',
    value: HotelSortBy.Price,
  },
  {
    key: 'search.hotelSortOptions.starRating',
    value: HotelSortBy.StarRating,
  },
]

export const BED_TYPE_OPTIONS: { key: string; value: HotelBedType }[] = [
  {
    key: 'search.bedTypeOptions.doubleBed',
    value: HotelBedType.DoubleBed,
  },
  {
    key: 'search.bedTypeOptions.twoDoubleBeds',
    value: HotelBedType.TwoDoubleBeds,
  },
  {
    key: 'search.bedTypeOptions.kingBed',
    value: HotelBedType.KingBed,
  },
  {
    key: 'search.bedTypeOptions.sofaBed',
    value: HotelBedType.SofaBed,
  },
  {
    key: 'search.bedTypeOptions.singleBed',
    value: HotelBedType.SingleBed,
  },
  {
    key: 'search.bedTypeOptions.twinBed',
    value: HotelBedType.TwinBed,
  },
  {
    key: 'search.bedTypeOptions.twoTwinBeds',
    value: HotelBedType.TwoTwinBeds,
  },
  {
    key: 'search.bedTypeOptions.queenBed',
    value: HotelBedType.QueenBed,
  },
  {
    key: 'search.bedTypeOptions.twoQueenBeds',
    value: HotelBedType.TwoQueenBeds,
  },
  {
    key: 'search.bedTypeOptions.bunkBed',
    value: HotelBedType.BunkBed,
  },
  {
    key: 'search.bedTypeOptions.any',
    value: HotelBedType.Any,
  },
]

export const VIEW_OPTIONS: { key: string; value: HotelViewType }[] = [
  {
    key: 'search.viewOptions.poolView',
    value: HotelViewType.PoolView,
  },
  {
    key: 'search.viewOptions.specialView',
    value: HotelViewType.SpecialView,
  },
  {
    key: 'search.viewOptions.cityView',
    value: HotelViewType.CityView,
  },
  {
    key: 'search.viewOptions.gardenView',
    value: HotelViewType.GardenView,
  },
  {
    key: 'search.viewOptions.any',
    value: HotelViewType.Any,
  },
]
export const ROOM_TYPE_OPTIONS: { key: string; value: HotelRoomType }[] = [
  {
    key: 'search.roomTypeOptions.standardRoom',
    value: HotelRoomType.StandardRoom,
  },
  {
    key: 'search.roomTypeOptions.deluxeRoom',
    value: HotelRoomType.DeluxeRoom,
  },
  {
    key: 'search.roomTypeOptions.superiorRoom',
    value: HotelRoomType.SuperiorRoom,
  },
  {
    key: 'search.roomTypeOptions.executiveRoom',
    value: HotelRoomType.ExecutiveRoom,
  },
  {
    key: 'search.roomTypeOptions.familyRoom',
    value: HotelRoomType.FamilyRoom,
  },
  {
    key: 'search.roomTypeOptions.accessibleRoom',
    value: HotelRoomType.AccessibleRoom,
  },
  {
    key: 'search.roomTypeOptions.juniorSuite',
    value: HotelRoomType.JuniorSuite,
  },
  {
    key: 'search.roomTypeOptions.suite',
    value: HotelRoomType.Suite,
  },
  {
    key: 'search.roomTypeOptions.any',
    value: HotelRoomType.Any,
  },
]

export const MEALS_INCLUDED_OPTIONS: {
  key: string
  value: HotelMealsIncluded
}[] = [
  {
    key: 'search.mealsOptions.none',
    value: HotelMealsIncluded.None,
  },
  {
    key: 'search.mealsOptions.breakfast',
    value: HotelMealsIncluded.Breakfast,
  },
  {
    key: 'search.mealsOptions.halfBoard',
    value: HotelMealsIncluded.HalfBoard,
  },
  {
    key: 'search.mealsOptions.fullBoard',
    value: HotelMealsIncluded.FullBoard,
  },
  {
    key: 'search.mealsOptions.allInclusive',
    value: HotelMealsIncluded.AllInclusive,
  },
  {
    key: 'search.mealsOptions.selfCatering',
    value: HotelMealsIncluded.SelfCatering,
  },
  {
    key: 'search.mealsOptions.any',
    value: HotelMealsIncluded.Any,
  },
]

export const REFUNDABLE_OPTIONS: { key: string; value: HotelRefundability }[] =
  [
    {
      key: 'search.refundabilityOptions.any',
      value: HotelRefundability.Any,
    },
    {
      key: 'search.refundabilityOptions.refundableOnly',
      value: HotelRefundability.RefundableOnly,
    },
  ]
